import React from 'react'
import BoxIcon from 'SVGS/BoxIcon'

const NoDataFound = ({ heading = "No Data", className = "" }) => {
    return (
        <div className={`w-full p-2  flex flex-col justify-center items-center text-secondaryLight opacity-55 ${className}`}>
            <BoxIcon className={"inline"} />
            <p className="mt-1 text-sm font-semibold pointer-events-none select-none">     {heading}   </p>
        </div>
    )
}

export default NoDataFound